import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import DSR_Services from "../../../Services/Reports/DSR_Services"
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function DSR4() {
  const mystyle = {
    border: " 1px solid Red",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };

  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [reportProcs, setreportProcs] = useState(false)
  const [clearProcs, setclearProcs] = useState(false)
  // const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false)

  const [dsr3Values, setdsr3Values] = useState({
    from: getDate(),
    to: getDate(),
    iec_no:''
  });
  const fromhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, to: e.target.value })
  };
  const IecNoHandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, iec_no: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
 
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///getfunctions
  const getfunctions = () => {
    // DSR_Services.selectBranchDetails().then(res => {
    //   setdetails1(res.data);
    // })
    DSR_Services.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations===>
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var importer_iec_no = '';
    if (dsr3Values.iec_no === 'ALL') {
      importer_iec_no = '-1'
    } else {
      importer_iec_no = dsr3Values.iec_no
    }
    
  
    let details = {
      fromDate: dsr3Values.from, toDate: dsr3Values.to, importer_iec_no: importer_iec_no
    }
    DSR_Services.getDSR_Report4(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === '' || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        // setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const reportBtnClick = () => {
    setreportProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setreportProcs(false)
    } else {
      var  contenall = '';
      for (let i = 0; i < details3.length; i++) {
        var tableContent = '';
        if (details3[i].bl_no !== '') {
          tableContent += details3[i].bl_no + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].mbl_no !== '') {
          tableContent += details3[i].mbl_no + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].hbl_no !== '') {
          tableContent += details3[i].hbl_no + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].boe_no !== '') {
          tableContent += details3[i].boe_no + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].boe_date !== '') {
          tableContent += details3[i].boe_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_no !== '') {
          tableContent += details3[i].invoice_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_date !== '') {
          tableContent += details3[i].invoice_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supplier_name !== '') {
          tableContent += details3[i].supplier_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supplier_address !== '') {
          tableContent += details3[i].supplier_address + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].releated_supplier !== '') {
          tableContent += details3[i].releated_supplier + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].country_of_origin !== '') {
          tableContent += details3[i].country_of_origin + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].port_of_origin !== '') {
          tableContent += details3[i].port_of_origin + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].port_of_discharge !== '') {
          tableContent += details3[i].port_of_discharge + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_value !== '') {
          tableContent += details3[i].invoice_value + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_currency !== '') {
          tableContent += details3[i].invoice_currency + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].freight_value !== '') {
          tableContent += details3[i].freight_value + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].freight_currency !== '') {
          tableContent += details3[i].freight_currency + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insurance_value !== '') {
          tableContent += details3[i].insurance_value + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insurance_currency !== '') {
          tableContent += details3[i].insurance_currency + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].freight_exchange_rate !== '') {
          tableContent += details3[i].freight_exchange_rate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insurance_exchange_rate !== '') {
          tableContent += details3[i].insurance_exchange_rate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].product_description !== '') {
          tableContent += details3[i].product_description + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].quantity !== '') {
          tableContent += details3[i].quantity + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unit !== '') {
          tableContent += details3[i].unit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unit_price !== '') {
          tableContent += details3[i].unit_price + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].item_currency !== '') {
          tableContent += details3[i].item_currency + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hsn !== '') {
          tableContent += details3[i].hsn + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].item_assessable_val !== '') {
          tableContent += details3[i].item_assessable_val + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].item_freight_amt !== '') {
          tableContent += details3[i].item_freight_amt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].item_ins_amt !== '') {
          tableContent += details3[i].item_ins_amt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cif_value !== '') {
          tableContent += details3[i].cif_value + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].loading !== '') {
          tableContent += details3[i].loading + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcd_rate !== '') {
          tableContent += details3[i].bcd_rate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcd_noft_no !== '') {
          tableContent += details3[i].bcd_noft_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcd_srl_no !== '') {
          tableContent += details3[i].bcd_srl_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcd_amount !== '') {
          tableContent += details3[i].bcd_amount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sws_rate !== '') {
          tableContent += details3[i].sws_rate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sws_amt !== '') {
          tableContent += details3[i].sws_amt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gstRate !== '') {
          tableContent += details3[i].gstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gst_noti_no !== '') {
          tableContent += details3[i].gst_noti_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gst_value !== '') {
          tableContent += details3[i].gst_value + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ttl_duty !== '') {
          tableContent += details3[i].ttl_duty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNotNo !== '') {
          tableContent += details3[i].addNotNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].Anty_Dumping_Rate !== '') {
          tableContent += details3[i].Anty_Dumping_Rate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].Anty_Dumping_duty !== '') {
          tableContent += details3[i].Anty_Dumping_duty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bond_no !== '') {
          tableContent += details3[i].bond_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sapta_noti !== '') {
          tableContent += details3[i].sapta_noti + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sapta_noti_slno !== '') {
          tableContent += details3[i].sapta_noti_slno + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sapta_desc !== '') {
          tableContent += details3[i].sapta_desc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sapta_duty_qty !== '') {
          tableContent += details3[i].sapta_duty_qty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sapta_duty_amt !== '') {
          tableContent += details3[i].sapta_duty_amt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].svb_referance_no !== '') {
          tableContent += details3[i].svb_referance_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].svb_load_on_type !== '') {
          tableContent += details3[i].svb_load_on_type + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_serial_no !== '') {
          tableContent += details3[i].invoice_serial_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoice_term !== '') {
          tableContent += details3[i].invoice_term + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].duty_benifit !== '') {
          tableContent += details3[i].duty_benifit + "!"
        } else {
          tableContent += '  !';
        }
       
        if (details3[i].cha !== '') {
          tableContent += details3[i].cha + "#"
        } else {
          tableContent += '  #';
        }
       
        contenall += tableContent;
      }

      
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DSR REPORT 4", headerDetails: "1,1,FROM DATE : " + dsr3Values.from + "/4,1,TO DATE : " + dsr3Values.to,
        tableHeader:"0,3,Sl.No/1,3,Job No/2,3,MBL No/3,3,HBL No/4,3,Boe No/5,3,Boe Date/6,3,Invoice no/7,3,Invoice Date/8,3,Supplier Name/9,3,Supplier Address/10,3,Releated Supplier/11,3,Country Of Origin/12,3,Port Of Origin/13,3,Port Of Discharge/14,3,Invoice Value/15,3,Invoice Currency/16,3,Freight Value/17,3,Freight Currency/18,3,Insurance Value/19,3,Insurance Currency/20,3,Freight Exchange Rate/21,3,Insurance Exchange Rate/22,3,Product Description/23,3,Quantity/24,3,Unit/25,3,Unit Price/26,3,Item Currency/27,3,HSN/28,3,Item Assessable Val/29,3,Item Freight Amt/30,3,Item Ins Amt/31,3,Cif Value/32,3,Loading/33,3,Bcd Rate/34,3,Bcd Noft No/35,3,Bcd Srl No/36,3,Bcd Amount/37,3,SWS Rate/38,3,SWS Amount/39,3,GstRate/40,3,Gst Noti No/41,3,GST Value/42,3,Total Duty/43,3,AddNotNo/44,3,Anty_Dumping_Rate/45,3,Anty_Dumping_duty/46,3,bond_no/47,3,sapta_noti/48,3,sapta_noti_slno/49,3,sapta_desc/50,3,sapta_duty_qty/51,3,sapta_duty_amt/52,3,svb_referance_no/53,3,svb_load_on_type/54,3,invoice_serial_no/55,3,invoice_term/56,3,duty_benifit/57,3,cha",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "dsr4", totalNumberOfColumn: 58, tableContent: contenall.substring(0, contenall.length - 1),
      }
      console.log(contenall)
      DSR_Services.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setreportProcs(false)
  }
  const clrBtnClick = () => {
    setclearProcs(true)
    setshowProcs(false)
    setdsr3Values({ ...dsr3Values, from: getDate(), to: getDate(), iec_no:'' })
    setdetails3([])
    setFilteredDetails([])
    setreportProcs(false)
    setclearProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);


  //tableSearch
  // const branchNmSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { branchNmOnchange(e.target.value) }} />
  // }
  // const opertionTypeSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { opertionTypeOnchange(e.target.value) }} />
  // }
  // const jobNoSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { jobNoOnchange(e.target.value) }} />
  // }
  // const impNmSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { impNmOnchange(e.target.value) }} />
  // }
  // const impcitySrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { impcityOnchange(e.target.value) }} />
  // }
  // const PortCdSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { PortCdOnchange(e.target.value) }} />
  // }
  // const cntryOrginSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { cntryOrginOnchange(e.target.value) }} />
  // }
  // const portOriginSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { portOriginOnchange(e.target.value) }} />
  // }
  // const modeofTrnsportSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { modeofTrnsportOnchange(e.target.value) }} />
  // }
  // const reportingPortSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { reportingPortOnchange(e.target.value) }} />
  // }
  // const invoiceNoSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  // }
  // const SupplierNmSrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { SupplierNmOnchange(e.target.value) }} />
  // }
  // const SuppliercntrySrch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { SuppliercntryOnchange(e.target.value) }} />
  // }
  // const itemDesc1Srch = () => {
  //   return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
  //     onChange={(e) => { itemDesc1Onchange(e.target.value) }} />
  // }
  //
  // const branchNmOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const opertionTypeOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.operationType.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const jobNoOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const impNmOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const impcityOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.importerCity.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const PortCdOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.cusHouseCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const cntryOrginOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.countryOfOrigin.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const portOriginOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.origin_portName.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const modeofTrnsportOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.transitTypeCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const reportingPortOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.gateWay_port_code.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const invoiceNoOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.invoiceNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const SupplierNmOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.supName.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const SuppliercntryOnchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.supCountry.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  // const itemDesc1Onchange = (searchedVal) => {
  //   const filteredvalue = details3.filter((trns) => {
  //     return trns.item_description.toString().toLowerCase().includes(searchedVal.toLowerCase())
  //   })
  //   if (filteredvalue.length < 1) {
  //     setFilteredDetails(details3)
  //   } else {
  //     setFilteredDetails(filteredvalue)
  //   }
  // }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Row>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>DSR-4 REPORT</center></div>
              
              <Col><center>
                <label style={mystyle1}>From Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={dsr3Values.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>To Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={dsr3Values.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Iec No</label>
                <Form.Control size="sm"  style={mystyle} value={dsr3Values.iec_no} onChange={IecNoHandlechange} />
                </center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Importer Name</label>
                <Form.Select type="text" list="code" style={mystyle} size="sm" value={dsr3Values.iec_no} onChange={IecNoHandlechange}>
                  <option value={'-1'}>ALL</option>
                  {details2.map(trns => (
                    <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                  ))}
                </Form.Select></center>
              </Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={reportBtnClick}>{reportProcs ? 'processing...' : 'Report'}</Button>
                &nbsp;
                <Button variant="danger"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={clrBtnClick}> {clearProcs ? 'processing...' : 'Reset'} </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                       <StyledTableCell>bl_no{/*{branchNmSrch()}*/}</StyledTableCell> 
                      <StyledTableCell>boe_no{/*opertionTypeSrch()*/}</StyledTableCell>
                      <StyledTableCell>boe_date{/*jobNoSrch()*/}</StyledTableCell>
                      <StyledTableCell>invoice_no</StyledTableCell>
                      <StyledTableCell>invoice_date</StyledTableCell>
                      <StyledTableCell>supplier_name</StyledTableCell>
                      <StyledTableCell>supplier_address</StyledTableCell>
                      <StyledTableCell>releated_supplier{/*impNmSrch()*/}</StyledTableCell>
                      <StyledTableCell>country_of_origin</StyledTableCell>
                      <StyledTableCell>port_of_origin</StyledTableCell>
                      <StyledTableCell>port_of_discharge{/*impcitySrch()*/}</StyledTableCell>
                      <StyledTableCell>invoice_value</StyledTableCell>
                      <StyledTableCell>invoice_currency</StyledTableCell>
                      {/* <StyledTableCell>PortCode{PortCdSrch()}</StyledTableCell>
                      <StyledTableCell>CountryOfOrigin{cntryOrginSrch()}</StyledTableCell>
                      <StyledTableCell>PortOfOrigin{portOriginSrch()}</StyledTableCell>
                      <StyledTableCell>CountryOfCM</StyledTableCell>
                      <StyledTableCell>CertificateStateCode</StyledTableCell>
                      <StyledTableCell>CertificateType</StyledTableCell>
                      <StyledTableCell>CertificateNo</StyledTableCell>
                      <StyledTableCell>TotalFreightRate</StyledTableCell>
                      <StyledTableCell>TotalInsuranceRate</StyledTableCell>
                      <StyledTableCell>TotalMischarge</StyledTableCell>
                      <StyledTableCell>TotalAssessibleValue</StyledTableCell>
                      <StyledTableCell>TotalDuty</StyledTableCell>
                      <StyledTableCell>GrossWeight</StyledTableCell>
                      <StyledTableCell>TotalInsurance</StyledTableCell>
                      <StyledTableCell>ModeOfTransport{modeofTrnsportSrch()}</StyledTableCell>
                      <StyledTableCell>IGM_SerialNo</StyledTableCell>
                      <StyledTableCell>RotationNo</StyledTableCell>
                      <StyledTableCell>RotationDate</StyledTableCell>
                      <StyledTableCell>MAWB/MBL_No</StyledTableCell>
                      <StyledTableCell>MAWB/MBL_Date</StyledTableCell>
                      <StyledTableCell>HAWB/HBL_No</StyledTableCell>
                      <StyledTableCell>HAWB/HBL_Date</StyledTableCell>
                      <StyledTableCell>InwardDate</StyledTableCell>
                      <StyledTableCell>NoofPkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>Unit</StyledTableCell>
                      <StyledTableCell>GatewayIGM_No</StyledTableCell>
                      <StyledTableCell>GatewayIGM_Date</StyledTableCell>
                      <StyledTableCell>ReportingPort{reportingPortSrch()}</StyledTableCell>
                      <StyledTableCell>TotalDuty1</StyledTableCell>
                      <StyledTableCell>InvoiceSrNo</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceDate</StyledTableCell>
                      <StyledTableCell>InvoiceValue</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>InvoiceExRate</StyledTableCell>
                      <StyledTableCell>InvoiceTerms</StyledTableCell>
                      <StyledTableCell>NatureTransaction</StyledTableCell>
                      <StyledTableCell>PaymentTerms</StyledTableCell>
                      <StyledTableCell>SupplierName{SupplierNmSrch()}</StyledTableCell>
                      <StyledTableCell>SupplierAddress1</StyledTableCell>
                      <StyledTableCell>SupplierAddress2</StyledTableCell>
                      <StyledTableCell>SupplierAddress3</StyledTableCell>
                      <StyledTableCell>SupplierCountry{SuppliercntrySrch()}</StyledTableCell>
                      <StyledTableCell>FreightValue</StyledTableCell>
                      <StyledTableCell>FreightCurrency</StyledTableCell>
                      <StyledTableCell>FreightRate</StyledTableCell>
                      <StyledTableCell>InsuranceValue</StyledTableCell>
                      <StyledTableCell>InsuranceCurrency</StyledTableCell>
                      <StyledTableCell>InsuranceRate</StyledTableCell>
                      <StyledTableCell>TotalInsurance</StyledTableCell>
                      <StyledTableCell>LoadCurrency</StyledTableCell>
                      <StyledTableCell>LoadRate</StyledTableCell>
                      <StyledTableCell>MiscCharge</StyledTableCell>
                      <StyledTableCell>MiscCurrency</StyledTableCell>
                      <StyledTableCell>MiscRate</StyledTableCell>
                      <StyledTableCell>HSSLoadAmount</StyledTableCell>
                      <StyledTableCell>HSSLoadRate</StyledTableCell>
                      <StyledTableCell>DiscountRate</StyledTableCell>
                      <StyledTableCell>DiscountAmount</StyledTableCell>
                      <StyledTableCell>SVBLoadOnDuty</StyledTableCell>
                      <StyledTableCell>SellerName</StyledTableCell>
                      <StyledTableCell>SellerAddress1</StyledTableCell>
                      <StyledTableCell>SellerAddress2</StyledTableCell>
                      <StyledTableCell>SellerAddress3</StyledTableCell>
                      <StyledTableCell>SellerCountry</StyledTableCell>
                      <StyledTableCell>SellerPincode</StyledTableCell>
                      <StyledTableCell>DiscountRate1</StyledTableCell>
                      <StyledTableCell>DiscountAmount1</StyledTableCell>
                      <StyledTableCell>SVBLoadOnDuty1</StyledTableCell>
                      <StyledTableCell>ItemNo</StyledTableCell>
                      <StyledTableCell>ItemDescription1{itemDesc1Srch()}</StyledTableCell>
                      <StyledTableCell>ItemDescription2</StyledTableCell>
                      <StyledTableCell>Item_NoOfUnit</StyledTableCell>
                      <StyledTableCell>Item_UmitQty</StyledTableCell>
                      <StyledTableCell>Item_UnitPrice</StyledTableCell>
                      <StyledTableCell>Item_UnitCurrency</StyledTableCell>
                      <StyledTableCell>TotalAmount</StyledTableCell>
                      <StyledTableCell>TotalCurrency</StyledTableCell>
                      <StyledTableCell>RITC_Code</StyledTableCell>
                      <StyledTableCell>CTH_No</StyledTableCell>
                      <StyledTableCell>CETH_No</StyledTableCell> */}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {/* {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
                      {details3.map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.bl_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoice_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoice_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplier_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplier_address}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.releated_supplier}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.country_of_origin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.port_of_origin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.port_of_discharge}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoice_value}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoice_currency}</StyledTableCell>
                          {/* <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cusHouseCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfOrigin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.origin_portName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfCmName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateTypeDesc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totFrtRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totInsRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totMiscRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totAssesableVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totDuty}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totIns}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitTypeCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.rotNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.rotDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.MAWBNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawb_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.inwardDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unit}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_igmNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_port_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totDuty1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.exRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.terms_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.nattransaction}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.payTerms}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplierAddress}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supAddress2}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supAddress3}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supCountry}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insCur1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totIns1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.loadCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.loadRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hssLoadAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hssLoadRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.discRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.svbLoad}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress2}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress3}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellCountry}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellPincode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disrt1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disAmt1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.svbLoad1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.item_description}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemDesc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitQty}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitPri}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.ritc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cth}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.ceth}</StyledTableCell> */}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default DSR4;
